import * as windowActions from './window';

export type UIActions = windowActions.WindowActions;
export default windowActions;